import { LoadButton, NoDataMessage, isNoData } from '../shared';
import { MaintenanceIcon } from '../icons';
import { MaintenanceIntervalCard } from '../cards/MaintenanceIntervalCard';
import type { UseQueryResult } from '@tanstack/react-query';

interface MaintenanceTabProps {
  query: UseQueryResult<any>;
  loadEnabled: boolean;
  onLoad: () => void;
  disabled?: boolean;
}

export function MaintenanceTab({ query, loadEnabled, onLoad, disabled }: MaintenanceTabProps) {
  return (
    <div>
      {!loadEnabled && (
        <div className="flex flex-col items-center justify-center py-12">
          <MaintenanceIcon className="w-12 h-12 opacity-40 mb-4" />
          <p className="text-gray-400 text-sm mb-4">View recommended maintenance intervals and service items</p>
          <LoadButton label="Load Maintenance Schedule" onClick={onLoad} isLoading={false} isLoaded={false} disabled={disabled} />
        </div>
      )}

      {query.isLoading && (
        <p className="text-gray-500 text-sm text-center py-8">Loading maintenance schedule...</p>
      )}

      {query.error && !isNoData(query) && (
        <p className="text-red-400 text-sm text-center py-4">Error loading maintenance schedule</p>
      )}

      {isNoData(query) && (
        <NoDataMessage message="No maintenance schedule available for this vehicle" />
      )}

      {query.data?.data?.maintenance && !isNoData(query) && (
        <div className="space-y-3">
          {query.data.data.maintenance.map((interval: any, idx: number) => (
            <MaintenanceIntervalCard
              key={idx}
              interval={interval}
              defaultExpanded={idx < 3}
            />
          ))}
        </div>
      )}
    </div>
  );
}
